
import React from "react";

const ProcessSection: React.FC = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Ablauf & Prozess
          </span>
          <h2 className="animate-fade-in" style={{ animationDelay: '100ms' }}>
            So läuft dein Outdoor-Coaching ab
          </h2>
          <p className="mt-6 text-joerg-600 animate-fade-in" style={{ animationDelay: '200ms' }}>
            Ein strukturierter Prozess, der dich zu nachhaltigen Ergebnissen führt
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          <div className="relative pl-12 animate-fade-in">
            <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white font-bold text-lg">
              1
            </div>
            <div className="absolute left-5 top-10 w-px h-full bg-joerg-200"></div>
            <h3 className="text-xl font-semibold mb-4">Vorgespräch</h3>
            <p className="text-joerg-600 mb-4">
              In einem kurzen telefonischen oder Online-Vorgespräch klären wir deine Ziele und Erwartungen an das Coaching. So kann ich den Ablauf optimal auf deine Bedürfnisse abstimmen.
            </p>
          </div>
          
          <div className="relative pl-12 animate-fade-in" style={{ animationDelay: '150ms' }}>
            <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white font-bold text-lg">
              2
            </div>
            <div className="absolute left-5 top-10 w-px h-full bg-joerg-200"></div>
            <h3 className="text-xl font-semibold mb-4">Treffpunkt & Start</h3>
            <p className="text-joerg-600 mb-4">
              Wir treffen uns an einem vereinbarten Punkt am Rothsee. Nach einer kurzen Einführung und Ankommen beginnen wir mit einem ersten Gespräch, um ins Thema einzusteigen.
            </p>
          </div>
          
          <div className="relative pl-12 animate-fade-in" style={{ animationDelay: '300ms' }}>
            <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white font-bold text-lg">
              3
            </div>
            <div className="absolute left-5 top-10 w-px h-full bg-joerg-200"></div>
            <h3 className="text-xl font-semibold mb-4">Walk & Talk</h3>
            <p className="text-joerg-600 mb-4">
              Der Hauptteil des Coachings findet in Bewegung statt. Wir umrunden in gemütlichem Tempo den kleinen Rothsee (ca. 5 km) oder wählen je nach Bedarf eine andere Route. Wir gehen in deinem Tempo, während wir an deinen Themen arbeiten. Zwischendurch gibt es immer wieder Pausen für Reflexionen und spezifische Übungen.
            </p>
          </div>
          
          <div className="relative pl-12 animate-fade-in" style={{ animationDelay: '450ms' }}>
            <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white font-bold text-lg">
              4
            </div>
            <h3 className="text-xl font-semibold mb-4">Abschluss & Transfer</h3>
            <p className="text-joerg-600 mb-4">
              Zum Ende der Session fassen wir die Erkenntnisse zusammen und erarbeiten konkrete nächste Schritte. Wir besprechen, wie du die Impulse in deinen Alltag integrieren kannst.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
